import librariesGetCurrentLibraryType from './libraries_get_current_library_type_selector'

export default {
	librariesGetCurrentLibraryType,
}
